import React from 'react';
import { Slide, toast, ToastContainer } from 'react-toastify';
import '../../../../components/sniff-toast/index.scss';

const toastOpt = {
    position: 'bottom-right',
    autoClose: 2500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
};

const NotifComp = ({ data }) => (
    <div>
        <div className="snif-p snif-semibold">{data.title}</div>
        {data.sub && <div className="snif-p mt-1">{data.sub}</div>}
    </div>
);

export const toasterInfo = ({ title, sub, addedOpt = {} }) => toast.info(NotifComp, { data: { title, sub }, ...addedOpt });
export const toasterDark = ({ title, sub, addedOpt = {} }) => toast.dark(NotifComp, { data: { title, sub }, ...addedOpt });
export const toasterSuccess = ({ title, sub, addedOpt = {} }) => toast.success(NotifComp, { data: { title, sub }, ...addedOpt });

export const toasterDanger = ({ title, sub, addedOpt = {} }) => {
    const options = { ...toastOpt, ...addedOpt, data: { title, sub } };
    return toast.error(NotifComp, options);
};

const SniffToast = () => {
    return (
        <ToastContainer
            position="bottom-right"
            autoClose={2500}
            hideProgressBar={false}
            transition={Slide}
            newestOnTop
            closeOnClick
            pauseOnFocusLoss
            pauseOnHover={false}
            theme="colored"
            limit={3}
        />
    );
};

export default SniffToast;
